import { render, staticRenderFns } from "./video-component-output-tab.vue?vue&type=template&id=60b45bd4&"
import script from "./video-component-output-tab.vue?vue&type=script&lang=js&"
export * from "./video-component-output-tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports